export default "__VITE_ASSET__06bad0be__"